import React from 'react';
import { Styles } from '@contently/toolkit';
import useProsemirror from './hooks/useProsemirror';
import useUIStatePlugin from './hooks/useUIStatePlugin';
import useAnnotationPlugin from './hooks/useAnnotationPlugin';
import { EditorPlaceholder, EditorWrapper, LoadingMessage } from './baseComponents';
import { headlineSchema } from '../editor-core';
import useStoryContext from '../hooks/useStoryContext';

export default function HeadlineEditor({
  roomName,
  onDispatchTransaction,
  consumerApi,
  plugins,
  format
}) {
  const { title } = useStoryContext();
  const { editorReady, editorViewRef, editorEl, editorState, editorLoading } = useProsemirror(
    roomName,
    onDispatchTransaction,
    {
      schema: headlineSchema,
      consumerApi,
      menus: { topMenu: false, promptMenu: false, floatingMenu: false },
      plugins: plugins || [],
      title,
      format
    }
  );

  const { showDiff, readOnly, historyMode } = useUIStatePlugin(editorState);

  useAnnotationPlugin(editorReady, editorViewRef, editorState, consumerApi, historyMode);

  const normalHeadline = {
    fontWeight: "600",
    fontSize: "30px",
    fontFamily: '"Chronicle Text G2 A", "Chronicle Text G2 B", Georgia, "Times New Roman", Times, serif',
    color: Styles.colors.black,
    lineHeight: "43px",
    margin: "0"
  }

  const emailHeadline = {
    fontWeight: "400",
    fontSize: "16px",
    fontFamily: '"Chronicle Text G2 A", "Chronicle Text G2 B", Georgia, "Times New Roman", Times, serif',
    color: Styles.colors.black,
    margin: "0",
    paddingLeft: "14px",
    lineHeight: "22px",
    height: "28px"
  }

  const currentStyling = format === 'headline' ? normalHeadline : emailHeadline;

  if (editorLoading) return LoadingMessage();

  return (
    <EditorWrapper
      showDiff={showDiff}
      readOnly={readOnly}
      historyMode={historyMode}
      minHeight="25px"
      style={currentStyling}
    >
      <EditorPlaceholder ref={editorEl}></EditorPlaceholder>
    </EditorWrapper>
  );
}

export { headlineSchema };



// WEBPACK FOOTER //
// ./app/javascript/client/editor-ui/HeadlineEditor.jsx